import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useMentorList = (params?: any) => {
  return useQuery({
    queryKey: ['mentor-list', params],
    queryFn: async () => {
      const res = await request.get('/mentor', { params });
      return res.data;
    }
  });
};
